import React from 'react'
import { Updater, fromJSX, Widget, any } from 'widgets-for-react'
import { InviewProps } from '../blocksState'
import { KnowledgeSearchBarLayout } from './knowledgeSearchBarLayout'
import {
  KnowledgeSearchBarState
} from './knowledgeSearchBarState'

export type KnowledgeSearchBarBlock = {
  index: number
  inview?: InviewProps
  knowledgeSearchBarState: KnowledgeSearchBarState
}

export const knowledgeSearchBarWidget = (
  block: KnowledgeSearchBarBlock
): Widget<Updater<KnowledgeSearchBarState>> => {
  return any<Updater<KnowledgeSearchBarState>>([
    fromJSX(setState => (
      <KnowledgeSearchBarLayout
        {...block}
        query={block.knowledgeSearchBarState.query}
        setQuery={(newQuery: string) =>
          setState(s => ({ ...s, query: newQuery }))
        }
      />
    ))
  ])
}
